import request from '@/utils/request'

export const getTableData = params =>
  request.get('/customer-api/company-finances/page', params)

export const removeItem = id =>
  request.delete(`/customer-api/company-finances/${id}`)

export const getCurrencyList = () => request.get('/masterdata-api/rate/list')

export const addCompanyFinances = params =>
  request.post('/customer-api/company-finances', params)

export const getCurrenyRate = (date, currencyA) =>
  request.get(`/customer-api/customer/${date}/${currencyA}/to/USD`)

export const templateDownload = () =>
  request.get(
    '/customer-api/company-finances/template/pull',
    {},
    { responseType: 'blob' },
  )
